import ReactDOM from "react-dom";
import React from "react";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";

import "./locals/i18n";

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById("root")
);

